import { render, staticRenderFns } from "./ConfigUnitForm.vue?vue&type=template&id=87ebe4e0&scoped=true"
import script from "./ConfigUnitForm.vue?vue&type=script&lang=js"
export * from "./ConfigUnitForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigUnitForm.vue?vue&type=style&index=0&id=87ebe4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ebe4e0",
  null
  
)

export default component.exports